import { GetMetersResponseSchema, type GetMetersResponse } from '@vy/api-definition';
import { validateNotEmptyObject } from '@vy/utils';
import type { QueryClient } from 'react-query';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../../services/api';
import { queryKeys } from '../../../services/query-key/query-keys';
import { CustomUseQueryOptions } from '../requests-types/custom-use-query-options';

export function useMeters(options?: CustomUseQueryOptions<GetMetersResponse>) {
  const queryKey = queryKeys.meters();
  const metersQueryResponse = useQuery(queryKey, metersQuery, { suspense: true, ...options });

  validateNotEmptyObject(metersQueryResponse.data, 'Meters');

  return metersQueryResponse;
}

export async function prefetchMeters(queryClient: QueryClient) {
  return queryClient.prefetchQuery(queryKeys.meters(), metersQuery);
}

async function metersQuery() {
  const api = getPrivateApi();
  const getMetersResponse = await api.getMeters();

  return GetMetersResponseSchema.parse(getMetersResponse);
}
